import React from "react";
import {
  Card,
} from '@aws-amplify/ui-react';
import { Link } from 'react-router-dom';
//import PaymentAddressDetails from "./PaymentAddressDetails";
//import PaymentCartDetails from "./PaymentCartDetails";
import '@aws-amplify/ui-react/styles.css';
import Modal from 'react-modal';
// Import styles
import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/default-layout/lib/styles/index.css';
import * as cccrypto from "crypto-browserify";
// Amplify configured once in index.js (v6).

// Support contact details (single source of truth for this page).
const SUPPORT_EMAIL = 'customerservice@pawtectindia.com';
const SUPPORT_PHONE_1 = '+91-7506562266';
const SUPPORT_PHONE_2 = '+91-20-67445858';

const decrypt = function (encText) {
  var decoded = ''
  //console.log('encText-->' + encText);
  if (encText) {
    try {
      var m = cccrypto.createHash('md5');
      m.update('930F9A992F46338D7B32A2C6CD13F06C');
      var key = m.digest();
      var iv = '\x00\x01\x02\x03\x04\x05\x06\x07\x08\x09\x0a\x0b\x0c\x0d\x0e\x0f';
      var decipher = cccrypto.createDecipheriv('aes-128-cbc', key, iv);
      decoded = decipher.update(encText, 'hex', 'utf8');
      decoded += decipher.final('utf8');
    } catch (error) {
      //console.log('Error' + error);
    }
  }
  //console.log('decoded-->' + decoded);
  return decoded;
};

// Mask an email like "john.doe@gmail.com" -> "jo****@gmail.com" for reassurance
// without exposing the full address on screen.
const maskEmail = function (email) {
  if (!email || email.indexOf('@') < 0) {
    return 'your registered email';
  }
  const parts = email.split('@');
  const name = parts[0];
  const visible = name.slice(0, 2);
  return visible + '****@' + parts[1];
};

function SupportFooter() {
  return (
    <div className="payment-support-footer" style={{ marginTop: '24px', paddingTop: '12px', borderTop: '1px solid #e0e0e0' }}>
      <p>
        Need help? Call us between 9AM-5PM, Monday to Friday at{' '}
        <a href={'tel:' + SUPPORT_PHONE_1.replace(/[^+\d]/g, '')}>{SUPPORT_PHONE_1}</a>{' '}or{' '}
        <a href={'tel:' + SUPPORT_PHONE_2.replace(/[^+\d]/g, '')}>{SUPPORT_PHONE_2}</a>, or email{' '}
        <a href={'mailto:' + SUPPORT_EMAIL}>{SUPPORT_EMAIL}</a>.
      </p>
    </div>
  );
}

export default function Payment(props) {
  //console.log('propos-->' + JSON.stringify(props));
  // Guard the parse: a missing / invalid / expired encp must NOT blank the page.
  let resp = null;
  try {
    resp = JSON.parse(decrypt(props?.encp));
  } catch (error) {
    resp = null;
  }

  const customStyles = {
    content: {
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      transform: 'translate(-50%, -50%)',
    },
  };

  Modal.setAppElement('#root');

  const isSuccess = resp?.order_status === 'Success';
  const formsMailto = 'mailto:' + SUPPORT_EMAIL +
    (resp?.order_id ? '?subject=' + encodeURIComponent('Application forms for order ' + resp.order_id) : '');

  return (
    <Card>
      <div className="page-process-wrapper border-top">
        <div className="container">
          <div className="row no-gutters">
            <div className="col">
              {
                resp === null ? (
                  /* Fallback: could not load / decode the payment status. */
                  <div>
                    <h1>
                      <i className="icon-brochure" style={{ color: '#c0392b', marginRight: '8px' }} aria-hidden="true"></i>
                      We couldn't load your payment status
                    </h1>
                    <p>
                      Your payment may still have gone through. Please do not retry immediately.
                      Contact us with your order id and we will confirm the status for you.
                    </p>
                    <SupportFooter />
                  </div>
                ) : isSuccess ? (
                  <div>
                    <h1>
                      <i className="icon-payment-gateway" style={{ color: '#1e8449', marginRight: '8px' }} aria-hidden="true"></i>
                      Payment received — ₹{resp?.amount}
                    </h1>
                    <p>
                      Dear {resp?.billing_name}, thank you for enrolling under the Digit Pet Insurance policy.
                      We have received your payment of ₹{resp?.amount}.
                    </p>

                    <h2>Order ID</h2>
                    <p><strong>{resp?.order_id}</strong> — please keep this for your records.</p>

                    <h2>What happens next</h2>
                    <ol>
                      <li>You will receive a payment receipt and an application form for each pet at {maskEmail(resp?.billing_email)} (please check your spam/junk folder if you don't see it shortly).</li>
                      <li>Fill up and print each application form, then sign it.</li>
                      <li>Scan the signed form(s) and email them to{' '}
                        <a href={formsMailto}>{SUPPORT_EMAIL}</a>{' '}
                        <strong style={{ color: '#c0392b' }}>within 3 days</strong>.
                      </li>
                      <li>Go Digit will scrutinise and process the form(s) for policy issuance.</li>
                    </ol>
                    <p>
                      Please note: risk does not commence on payment, but on submission of your application form,
                      after which Go Digit General Insurance underwrites the risk. A Certificate of Insurance for
                      approved proposals is issued to your registered email after 64VB compliance.
                    </p>

                    <SupportFooter />
                  </div>
                ) : (
                  <div>
                    <h1>
                      <i className="icon-brochure" style={{ color: '#c0392b', marginRight: '8px' }} aria-hidden="true"></i>
                      Payment failed
                    </h1>
                    <p>
                      Dear {resp?.billing_name}, your payment of ₹{resp?.amount} could not be completed
                      {resp?.order_status ? ' (' + resp.order_status + ')' : ''}.
                      Your order id for this failed payment is <strong>{resp?.order_id}</strong>
                      {resp?.tracking_id ? <> and the tracking number is <strong>{resp?.tracking_id}</strong></> : null}.
                    </p>
                    <p>
                      If any amount was debited from your account, it auto-reverses to your original payment
                      method, usually within a few working days — you do not need to do anything.
                    </p>

                    <h2>What you can do</h2>
                    <ol>
                      <li>Return to your cart and retry the payment. A new order id and tracking number will be generated.</li>
                      <li>If the error repeats, contact customer service before trying again.</li>
                    </ol>

                    <div style={{ margin: '16px 0' }}>
                      <Link to="/" className="btn btn-submit">Return to cart / Retry payment</Link>
                    </div>

                    <SupportFooter />
                  </div>
                )
              }
            </div>
          </div>
        </div>
      </div>
      <div className="clearfix"></div>
      <Modal
        isOpen={false}
        style={customStyles}
        contentLabel="Pawtect Payment"
        ariaHideApp={false}
      >
      </Modal>
    </Card>
  );
}


